<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { stockAuthority } from "./api/common";
export default {
  created() {
    let dzhToken = this.getUrlKey("token");
    this.getAuthority(dzhToken);
    if (dzhToken) {
      this.$store.dispatch("app/setDzhToken", dzhToken);
    }
  },
  methods: {
    getUrlKey: function (name) {
      // eslint-disable-next-line no-sparse-arrays
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    getAuthority: function (token) {
      let url = "/api.php?need=335,350&func=dzh-doc&token=" + token;
      stockAuthority(url).then((res) => {
        if (res.data.err == 0) {
        } else {
          var jumpUrl = "";
          jumpUrl = res.data.data.noRightUrl;
          window.location = jumpUrl;
        }
      });
    },
  },
};
</script>
